import angular from 'angular';
import CategoriesSynchronousFilter from './categories-synchronous-filter.component';
// import categoriesInputFilter from './categories-input-filter/categories-input-filter';
// import CategoriesSliderFilterModule from './categories-slider-filter/categories-slider-filter';

let CategoriesSynchronousFilterModule = angular.module('catalog.categoriesSynchronousFilter', [
//   categoriesInputFilter.name,
//   CategoriesSliderFilterModule.name
])
  .component('categoriesSynchronousFilter', CategoriesSynchronousFilter);

export default CategoriesSynchronousFilterModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-synchronous-filter/categories-synchronous-filter.js
 **/